import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams, ShortDataModel } from 'Models'
import { RequestOptions } from 'Types/requestOptions'
import { KEYS } from 'Modules/Select'
import { Callback } from 'Src/types/utilTypes'

type dataType = Record<KEYS, ResponseCatalog<ShortDataModel> | ShortDataModel[]> | {}
type dataParams = Record<KEYS, RequestParams> | {}

type SelectState = {
	data: dataType
	requestParams: dataParams
}

const initialState: SelectState = {
	data: {},
	requestParams: {},
}

export namespace SelectNS {
	export type GetAllByKey = PayloadAction<{
		params?: RequestParams
		options?: RequestOptions
		key: KEYS
		callback?: Callback
	}>
	export type GetDictByKey = PayloadAction<{
		key: KEYS
		callback?: Callback
	}>
	export type ClearAllByKey = PayloadAction<KEYS>
	export type SetRequestParamsByKey = PayloadAction<{
		params: RequestParams
		key: KEYS
	}>
	export type SetAllByKey = PayloadAction<{
		data: ResponseCatalog<ShortDataModel> | ShortDataModel[]
		key: KEYS
	}>
	export type ClearAll = PayloadAction
}

export const selectSlice = createSlice({
	name: 'select',
	initialState,
	reducers: {
		getAllByKey: (state, action: SelectNS.GetAllByKey) => {},
		getDictByKey: (state, action: SelectNS.GetDictByKey) => {},
		clearAllByKey: (state, action: SelectNS.ClearAllByKey) => {
			state.data[action.payload] = new ResponseCatalog<ShortDataModel>()
			state.requestParams[action.payload] = new RequestParams()
		},
		setRequestParamsByKey: (state, action: SelectNS.SetRequestParamsByKey) => {
			state.requestParams[action.payload.key] = action.payload.params
		},
		setAllByKey: (state, action: SelectNS.SetAllByKey) => {
			state.data[action.payload.key] = action.payload.data
		},
		clearAll: (state, action: SelectNS.ClearAll) => {
			state.data = {}
			state.requestParams = {}
		},
	},
})
